import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = ['About', 'Current Projects', 'Watches', 'Socials', 'Build Service', 'Contact', 'Workshop Info'];

  const scrollToSection = (item) => {
    setMobileMenuOpen(false);

    if (item === 'Contact') {
      navigate('/contact');
      return;
    }

    if (item === 'Workshop Info') {
      navigate('/workshop-info');
      return;
    }

    // If we're not on home, go home first then scroll
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const sectionId = item.toLowerCase().replace(/ /g, '-');
        const element = document.getElementById(sectionId);
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
      return;
    }

    const sectionId = item.toLowerCase().replace(/ /g, '-');
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleLogoClick = () => {
    if (location.pathname !== '/') {
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById('socials');
        if (element) element.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      const element = document.getElementById('socials');
      if (element) element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-white/10">
      <div className="w-full px-4 md:px-8 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center flex-shrink-0 mr-8 md:mr-16 lg:mr-24">
            <button
              onClick={handleLogoClick}
              className="focus:outline-none"
              aria-label="Go to socials"
            >
              <img
                src="https://customer-assets.emergentagent.com/job_santiago-timepieces/artifacts/c175ms86_ct%26w.png"
                alt="CT&W"
                className="h-32 md:h-36 w-auto object-contain cursor-pointer hover:opacity-80 transition-opacity duration-300"
              />
            </button>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8 lg:space-x-10">
            {menuItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className={`text-white hover:text-gray-300 transition-colors duration-200 text-sm font-light tracking-wide whitespace-nowrap ${
                  item === 'Workshop Info' ? 'ml-8 lg:ml-12' : ''
                }`}
              >
                {item}
              </button>
            ))}
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden text-white"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {mobileMenuOpen && (
          <nav className="md:hidden mt-4 pb-4 flex flex-col space-y-4 border-t border-white/10 pt-4">
            {menuItems.map((item) => (
              <button
                key={item}
                onClick={() => scrollToSection(item)}
                className="text-white hover:text-gray-300 transition-colors duration-200 text-left"
              >
                {item}
              </button>
            ))}
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
